import React, { PropTypes } from 'react';
import Input from '../Input';
import YouTube from 'react-youtube';
import Vimeo from 'react-vimeo';
import 'react-vimeo/lib/Vimeo.css';
import { YOUTUBE_REGEXP, VIMEO_REGEXP} from '../../../utilites/helpers/constants';


const YOUTUBE_EXAMPLE = 'https://youtu.be/e_dAJj8mJak';
const VIMEO_EXAMPLE = 'https://vimeo.com/146782320';

class YouTubeInput extends React.Component {
  static propTypes = {
    label: PropTypes.node,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
  };

  static defaultProps = {
    label: 'YouTubeInput'
  };

  constructor(props) {
    super(props);
    const { value } = props;
    this.state = {
      value
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  extractId(regExp, url) {
    let matches = regExp.exec(url);
    return matches ? matches[matches.length - 1] : null;
  }

  onChange = (value) => {
    this.setState({ value: null }, () => {
      this.props.onChange(value);
    });
  };

  render() {
    const anyVideoId = 'av_i';
    const { required } = this.props;
    const { value } = this.state;
    const youtubeVideoId = value ? this.extractId(YOUTUBE_REGEXP, value) : null;
    const vimeoVideoId = value ? this.extractId(VIMEO_REGEXP, value) : null;

    return (
      <div>
        <Input
          id={anyVideoId}
          required={required}
          {...this.props}
          onChange={this.onChange}
        />
        <p>Please insert link to YouTube (i.e. <a href={YOUTUBE_EXAMPLE}>{YOUTUBE_EXAMPLE}</a>)</p>
        <p>or to Vimeo (i.e. <a href={VIMEO_EXAMPLE}>{VIMEO_EXAMPLE}</a>)</p>

        {youtubeVideoId ? <YouTube id="video-youtube" videoId={youtubeVideoId}/> : null}
        {vimeoVideoId ? <Vimeo videoId={ vimeoVideoId }/> : null}
      </div>
    );
  }
}

export default YouTubeInput;



// WEBPACK FOOTER //
// ./src/components/form/ExternalVideoInput/ExternalVideoInput.jsx